import React, { useEffect, useState, PropTypes } from "react";
import ReactDOM from "react-dom";
import { CONST } from "./constants";
import { config } from "../config";
import ProductContainer from "../components/ProductDetail/ProductContainer";
import QuoteButton from "../components/QuoteButton/QuoteButton";
import GemfindWishlistPage from "../components/RequestForQuotePage/GemfindWishlistPage";
import ProductListPage from "../components/ProductListPage/ProductListPage";
import { ToastContainer, toast } from "react-toastify";
import { LoadingOverlay, Loader } from "react-overlay-loader";
import { useCookies } from "react-cookie";
import "./custom.css";
const {
    ADD_TO_QUOTE_BTN,
    HIDE_PRICE,
    QUOTE_BUTTON,
    REQUEST_A_QUOTE_PAGE
} = CONST;

const App = () => {
    // console.log();
    //console.log("e.target.parentNode.parentNode.parentNode.id");
    const [getHandle, setHandle] = useState([]);
    const [loaded, setLoaded] = useState(false);
    // const [planUpgradable, setplanUpgradable] = useState(false);
    const [cookies, setCookie, removeCookie] = useCookies("gemfind_sessionId");

    // const [enableProdDetails, setEnableProdDetails] = useState();
    // const add_to_qoute_btn = document.querySelector(
    //     "." + config[ADD_TO_QUOTE_BTN].className
    // );
    // const request_for_quote_page = document.querySelector(
    //     "." + config[REQUEST_A_QUOTE_PAGE].className
    // );
    const qyt_btn = document.querySelector(
        "." + config[QUOTE_BUTTON].className
    );
    const add_to_qoute_btn = document.querySelector(
        "." + config[ADD_TO_QUOTE_BTN].className
    );
    const request_for_quote_page = document.querySelector(
        "." + config[REQUEST_A_QUOTE_PAGE].className
    );
    //ADDING HIDE CLASS TO COLLECTION PAGE
    function setClassToButton() {
        var collection_href =
            '.card__inner a.full-unstyled-link[href*="/products/"],.grid-product__content a[href*="/collections/"],.grid__item .grid-view-item a.full-width-link[href*="/products/"], .card a[href*="/products/"],.grid .grid-uniform .grid-item a[href*="/products/"],.grid__item .card-wrapper a[href*="/products/"]';
        var product_item =
            '.card > .card__inner .card__content,.collection-product-card,.sf__pcard,.product-item__content,.card-product__wrapper,.products .product-col,.pr_list_item,.pr_grid_item,product-item,.product-wrap,.tt-layout-product-item .tt-product,.products-grid .grid-item,.product-grid .indiv-product,.collection-page__product-list .product-item,.product-list [data-product-item],.product-list .product-block,.collection-products .collection-product,.collection__grid-loop .product-index,.product-thumbnail[data-product-thumbnail],.filters-results .product-list .card,.product-loop .product-index,#main-collection-product-grid .product-index,.collection-container .product,.featured-collection .product,.collection__grid-item,.collection-product,[data-product-grid-item],.product-grid-item.product-grid-item--featured,.collection__products .product-grid-item,.featured-collection__wrapper .grid__item,.collection-alternating-product,.product-list-item,.product-grid .grid__item,collection-product-grid [class*="column"],.collection-filters .product-grid-item,.product-grid .product-item,.featured-collection__content .featured-collection__item,.collection-grid .grid-item.grid-product,#CollectionProductGrid .collection-list li,.collection__products .product-item,.collection__products .product-item,#main-collection-product-grid .product-loop__item,.product-loop .product-loop__item,#product-grid .grid__item,.products #ajaxSection c:not(.card-price),#main-collection-products .product,.grid.gap-theme > li,.mainCollectionProductGrid .grid .block-product,.collection-grid-main .items-start > .block,.collection-list-products .grid__item .grid-product__wrapper,.s-collection__products .c-product-item,.products-grid .product,[data-section-type="collection"] .group.block,.blocklayout .block.product,.sf__pcard,.product-grid .product-block,.product-list .product-block .product-block__inner,.grid__item .product-card,.collection.grid .product-item .product-item__wrapper,.collection--body--grid .product--root,.o-layout__item .product-card,.productgrid--items .productgrid--item .productitem,.box__collection,.collection-page__product,.collection-grid__row .product-block .product-block__inner,.ProductList .Grid__Cell .ProductItem .ProductItem__Wrapper,.items .item .item__inner,.grid-flex .product-block,.product-loop .product,.collection__products .product-tile,.product-list .product-item,.grid__item .grid-product__content,.product-grid .grid-item .grid-item__content,.collection .product-item,.product-grid .grid__item .indiv-product,.collection__grid .product-card .product-card-info,.collection-list .block,.collection__products .product-item,.product--root[data-product-view=grid],.grid__wrapper .product-loop__item,.collection__list-item,.grid__item.grid__item--collection-template,.product-recommendations__inner .grid__item, #CollectionSection .grid-uniform .grid-item, #shopify-section-collection-template .product-item, #shopify-section-collection-template .grid__item, .collections__products .featured-collections__item,#product-grid .grid__item, .template-collection .grid--uniform .grid__item,.collection-grid-section:not(.shopify-section),.spf-product-card,.grid__item .card-wrapper,.grid-item';

        var handleInArray = [];

        document.querySelectorAll(collection_href).forEach(t => {
            var n = t
                .getAttribute("href")
                .substring(t.getAttribute("href").lastIndexOf("/"))
                .replace("/", "")
                .split("?")[0];
            if (-1 == n.indexOf(".")) {
                var addToQuoteElement = document.createElement("div");
                if (null != t.closest(product_item)) {
                    if (handleInArray.indexOf(n) === -1) {
                        handleInArray.push(n);
                        var a = t.closest(product_item);
                        setHandle(current => [...current, n]);
                        a.append(addToQuoteElement);
                        addToQuoteElement.setAttribute("id", n);
                        // console.log(n);
                        addToQuoteElement.classList.add(
                            "gemfind_wishlist_icon_class_q78er"
                        );
                    }
                }
            }
        });
    }

    const setOnLoadCookie = () => {
        if (!cookies.gemfind_sessionId) {
            var randomstring = require("randomstring");
            let cookieKey = randomstring.generate(); //size 49 by default
            setCookie("gemfind_sessionId", cookieKey, { path: "/" });
        }
    };

    //FOR UPDATE PRODUCT LIST AFTER LOGIN
    const updateproductInWishlist = async data => {
        const requestOptions = {
            method: "POST",
            body: JSON.stringify({
                shop_domain: window.Shopify.shop,
                session_id: cookies.gemfind_sessionId,
                product_id:
                    window.meta.pagepageType === "product"
                        ? window.meta.product.id
                        : "",
                handle: data,
                customer_id: window.meta.page.customerId
            })
        };
        const res = await fetch(
            `${process.env.REACT_APP_API_URL}` + "updateWishlist",
            requestOptions
        );
        const set_count = await res.json();
    };

    const handleToast = e => {
        toast(e);
    };

    // const wishlistCount = async data => {
    //     const requestOptions = {
    //         method: "POST",
    //         body: JSON.stringify({
    //             shop_domain: window.Shopify.shop,
    //         })
    //     };
    //     const res = await fetch(
    //         `${process.env.REACT_APP_API_URL}` + "wishlistCount",
    //         requestOptions
    //     );
    //     const set_count = await res.json();
    //     if (set_count) {
    //         if (set_count.data.wishlist_plan_upgradable) {
    //             setplanUpgradable(set_count.data.wishlist_plan_upgradable);
    //         }
    //     }

    // };

    // useEffect(() => {
    //     wishlistCount();
    // }, []);

    // END
    useEffect(() => {
        setLoaded(true);
        setClassToButton();
        setOnLoadCookie();
        if (window.meta.page.customerId != undefined) {
            {
                getHandle.map(data => {
                    updateproductInWishlist(data);
                });
            }
        }
        setLoaded(false);
    }, []);
    useEffect(()=>{
        if(loaded){
            document.querySelector(".gf--loader--body").style="display:block;";
        }else{
            document.querySelector(".gf--loader--body").style="display:none;";
        }
    },[loaded]);
    return (
        <>
            <LoadingOverlay className="_loading_overlay_wrapper gf--loader--body" >
                <Loader fullPage loading={true} />
            </LoadingOverlay>
            <style>
                {`
                    .react-overlay-loader-spinner {
                        background-image: url("${process.env.REACT_APP_IMAGE_URL}images/heart_loader.gif");
                    }
                    .gf--loader--body{
                        display:none;
                        z-index: 11111111;
                        position: relative;
                    }
                `}
            </style>
            {/* <LoadingOverlay className="_loading_overlay_wrapper">
                <Loader fullPage loading={loaded} />
            </LoadingOverlay> */}

            <ToastContainer
                position="top-center"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />

            {qyt_btn && ReactDOM.createPortal(<QuoteButton />, qyt_btn)}
            {add_to_qoute_btn && window.meta.product
                ? ReactDOM.createPortal(<ProductContainer />, add_to_qoute_btn)
                : null}
            {request_for_quote_page &&
                window.location.pathname === "/pages/gemfind-my-wishlist"
                ? ReactDOM.createPortal(
                    <GemfindWishlistPage />,
                    request_for_quote_page
                )
                : null}
            {getHandle.map(data => {
                return ReactDOM.createPortal(
                    <ProductListPage props={data} callback={handleToast} />,
                    document.getElementById(data)
                );
            })}
        </>
    );
};

export default App;
